import React, { useState } from "react";
import Head from "next/head";
import FeaturedBlogs from "../../../components/VLSI/featuredBlogs";
import Menu from "../../../components/VLSI/menu";
import MobileMenu from "../../../components/VLSI/mobileMenu";
import Modal from "../../../components/VLSI/modal";
import { redirectTo500 } from "../../../utils/utility";
import ghost from "../../../utils/ghost";
import Image from "next/image";
import Footer from "../../../components/VLSI/footer";
import MobileFooter from "../../../components/VLSI/mobileFooter";

export async function getStaticProps(context) {
  const featuredData = await ghost({
    filter: "tags:blog" + "+tags:vlsi",
    pagination: { limit: 3 },
  });
  const listPagedData = await ghost({
    filter: "tags:blog" + "+featured:false",
    pagination: { limit: "all" },
  });

  if (!featuredData || !listPagedData) {
    return redirectTo500();
  }
  return {
    props: {
      featured: featuredData,
      listData: listPagedData,
    },
    revalidate: 3600,
  };
}

const PhysicalDesign = (props) => {
  const addBackground = () => {
    let element = document.getElementById("dynamic-menu-image-section");
    element.classList.add("bg-blue-500");
  };
  // modal state
  const [showModal, setShowModal] = useState(false);
  const handleOnClose = () => setShowModal(false);
  return (
    <div>
      <Head>
        <title>PD | Harware Solution in Bangladesh</title>
        <meta
          name="description"
          content="More than 20 years of experience in developing large-scale enterprise software solutions both locally and globally. Extensive experience in developing complex e-Service solutions for the government of Bangladesh with nationwide implementation."
        />
      </Head>
      <div className="negative-margin sticky top-0 z-50">
        <header className="hidden lg:block w-full bg-black sticky top-0 z-50">
          <Menu />
        </header>
        <header className="block lg:hidden w-full bg-black sticky top-0 z-50">
          <MobileMenu />
        </header>
      </div>
      {/* home content */}
      {/* hero section */}
      <section className="bg-gray-50">
        <div className=" max-w-screen-xl mx-auto">
          <div className="flex items-center justify-between  p-7 lg:py-24 lg:px-[30px]">
            <div className=" lg:basis-1/2 flex flex-col gap-3 sm:gap-6">
              <span className="text-2xl sm:text-4xl lg:text-6xl font-extrabold">
                Your one stop RTL-to-GDSII solution!
              </span>
              <p className="lg:text-xl text-gray-500 leading-relaxed">
                Your complete RTL-to-GDSII solution, delivering efficiency and
                expertise at every step of the process. Trust us to bring your
                semiconductor designs to life seamlessly and successfully.
              </p>
              <div className=" mt-2 flex gap-4">
                <button
                  onClick={() => {
                    setShowModal(true);
                  }}
                  className=" inline-flex items-center gap-2 px-5 py-3 bg-[#1A56DB] hover:bg-blue-800 text-white  "
                >
                  Contact Us <img src="/images/VLSI/ic/arrow-right.svg" />
                </button>
                <a
                  href="#second_section_PD"
                  className=" inline-flex px-5 py-3 bg-gray-50 hover:bg-gray-100  border border-gray-200 "
                >
                  Learn More
                </a>
              </div>
            </div>
            <div className="hidden lg:inline-block">
              <img
                src="/images/VLSI/physicaldesign/hero_section_image.png"
                className="max-w-full h-auto"
              />
            </div>
          </div>
        </div>
      </section>
      {/* modal */}
      <Modal visible={showModal} onClose={handleOnClose} />
      {/* modal ENDS */}
      {/* hero section ENDS */}

      {/* 2nd section */}
      <section className="bg-gray-50" id="second_section_PD">
        <div className="max-w-screen-xl mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 p-7 lg:py-16 lg:px-[30px]">
            {/* left card */}
            <div className="bg-gray-100 border border-gray-200 p-6 lg:p-12 flex flex-col gap-3 grow basis-0">
              <div className=" text-xs font-medium px-2.5 py-1.5 text-green-800 bg-green-100 w-fit inline-flex gap-1">
                <img src="/images/VLSI/physicaldesign/swatchbook.svg" />{" "}
                Integrate
              </div>
              <div className="text-gray-900 text-xl lg:text-2xl font-extrabold ">
                We seamlessly integrate with your team.
              </div>
              <div className="lg:text-xl text-gray-500 leading-relaxed">
                With a firm belief that great collaboration leads to the
                creation of exceptional products
              </div>
            </div>
            {/* right card */}
            <div className="bg-gray-100 border border-gray-200 p-6 lg:p-12 flex flex-col gap-3 grow basis-0">
              <div className=" text-xs font-medium px-2.5 py-1.5 text-purple-800 bg-purple-100 w-fit inline-flex gap-1">
                <img src="/images/VLSI/physicaldesign/code.svg" /> Turn-Key
                Solution
              </div>
              <div className="text-gray-900 text-xl lg:text-2xl font-extrabold ">
                Turn-key design solutions for you.
              </div>
              <div className="lg:text-xl text-gray-500 leading-relaxed">
                Our in-house PD flow and exhaustive checklist takes care of GDS
                quality for manufacturing and signoff/PPA requirement
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* 2nd section */}

      {/* 3rd section  */}
      <section className="bg-gray-50">
        <div className=" max-w-screen-xl mx-auto p-7 lg:py-24 lg:px-[30px]">
          <div className="flex gap-16">
            {/* left side bar */}
            <div className="hidden lg:block basis-2/5 sticky top-20 self-start py-24">
              {/* tab-1 */}
              <a
                href="#PDK"
                className="flex gap-3 items-center text-gray-500 font-medium"
              >
                <img
                  src="/images/VLSI/physicaldesign/PDK & Library Evaluation.svg"
                  className=" w-10"
                />
                PDK & Library Evaluation
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -2 */}
              <a
                href="#SYN"
                className="flex gap-3 items-center text-gray-500 font-medium"
              >
                <img
                  src="/images/VLSI/physicaldesign/Synthesis.svg"
                  className=" w-10"
                />
                Synthesis
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -3 */}
              <a
                href="#DFT"
                className="flex gap-3 items-center text-gray-500 font-medium"
              >
                <img
                  src="/images/VLSI/physicaldesign/DFT and ATPG.svg"
                  className=" w-10"
                />
                DFT and ATPG
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -4 */}
              <a
                href="#FV"
                className="flex gap-3 items-center text-gray-500 font-medium"
              >
                <img
                  src="/images/VLSI/physicaldesign/Formal Verification.svg"
                  className=" w-10"
                />
                Formal Verification
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -5 */}
              <a
                href="#PR"
                className="flex gap-3 items-center text-gray-500 font-medium"
              >
                <img
                  src="/images/VLSI/physicaldesign/Place and Route.svg"
                  className=" w-10"
                />
                Place and Route
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -6 */}
              <a
                href="#PV"
                className="flex gap-3 items-center text-gray-500 font-medium"
              >
                <img
                  src="/images/VLSI/physicaldesign/Physical Verification.svg"
                  className=" w-10"
                />
                Physical Verification
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -7 */}
              <a
                href="#TC"
                className="flex gap-3 items-center text-gray-500 font-medium"
              >
                <img
                  src="/images/VLSI/physicaldesign/Timing Closure.svg"
                  className=" w-10"
                />
                Timing Closure
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>

              {/* tab -8 */}
              <a
                href="#PA"
                className="flex gap-3 items-center text-gray-500 font-medium"
              >
                <img
                  src="/images/VLSI/physicaldesign/Power IR Analysis.svg"
                  className=" w-10"
                />
                Power/IR Analysis
              </a>
              <div className="ml-[18px] h-12 bg-gray-200/50 w-[1px]"></div>
              {/* tab -9 */}
              <a
                href="#ECO"
                className="flex gap-3 items-center text-gray-500 font-medium"
              >
                <img
                  src="/images/VLSI/physicaldesign/Post-Silicon ECO.svg"
                  className=" w-10"
                />
                Post-Silicon ECO
              </a>
              {/* <div className="ml-[18px] h-12 bg-gray-100 w-[1px]"></div> */}
            </div>
            {/* left side bar ENDS */}
            {/* right side content */}
            <div className="flex flex-col gap-10">
              {/* card 1 */}
              <div
                className="bg-gray-100 p-8 lg:px-16 lg:py-24 shadow-lg"
                id="PDK"
              >
                <div className="flex flex-col lg:flex-row-reverse lg:items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl lg:text-4xl font-extrabold text-gray-900">
                      PDK & Library Evaluation
                    </span>
                    <ul className="leading-normal mt-4 text-gray-500 lg:text-lg flex flex-col gap-1">
                      <li>
                        PPA analysis for multiple frequencies, technology node,
                        standard cell libraries to pick the most suitable node
                        and constraints
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div className="self-center">
                    <img src="/images/VLSI/physicaldesign/pdk_library_evaluation.png" />
                  </div>
                </div>
              </div>

              {/* card 2 */}
              <div
                className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg"
                id="SYN"
              >
                <div className="flex flex-col lg:flex-row lg:items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl lg:text-4xl font-extrabold text-gray-900">
                      Synthesis
                    </span>
                    <ul className="list-disc list-outside leading-relaxed mt-4 text-gray-500 lg:text-lg flex flex-col gap-1">
                      <li>Physical-aware</li>
                      <li>CPF/UPF</li>
                      <li>3rd Party IP integration</li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div className="self-center">
                    <img src="/images/VLSI/physicaldesign/synthesis.png" />
                  </div>
                </div>
              </div>

              {/* card 3 */}
              <div
                className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg"
                id="DFT"
              >
                <div className="flex flex-col lg:flex-row-reverse lg:items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl lg:text-4xl font-extrabold text-gray-900">
                      DFT Insertion
                    </span>
                    <ul className="list-disc list-outside leading-relaxed mt-4 text-gray-500 lg:text-lg flex flex-col gap-1">
                      <li>ATPG and Coverage Analysis</li>
                      <li>ATPG Simulation</li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div className="self-center">
                    <img src="/images/VLSI/physicaldesign/dft_Insertion.png" />
                  </div>
                </div>
              </div>

              {/* card 4 */}
              <div
                className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg"
                id="FV"
              >
                <div className="flex flex-col lg:flex-row lg:items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl lg:text-4xl font-extrabold text-gray-900">
                      Formal Verification
                    </span>
                    <ul className=" leading-relaxed mt-4 text-gray-500 lg:text-lg flex flex-col gap-1">
                      <li>
                        RTL to gate-level and gate-level to post-layout LEC to
                        ensure functional integrity
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div className="self-center">
                    <img src="/images/VLSI/physicaldesign/formal_verification.png" />
                  </div>
                </div>
              </div>

              {/* card 5 */}
              <div
                className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg"
                id="PR"
              >
                <div className="flex flex-col lg:flex-row-reverse lg:items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl lg:text-4xl font-extrabold text-gray-900">
                      Place and Route
                    </span>
                    <ul className="list-disc list-outside leading-relaxed mt-4 text-gray-500 lg:text-lg flex flex-col">
                      <li>LEF/DEF Flow</li>
                      <ul className="list-disc list-outside ml-4">
                        <li>Digital Top</li>
                        <li>Integration of Analog blocks</li>
                      </ul>
                      <li className="mt-2">EDI-OA Interoperability</li>
                      <ul className="list-disc list-outside  ml-4">
                        <li>Mixed-Signal, Analog-on-top</li>
                      </ul>
                    </ul>
                  </div>
                  {/* right content */}
                  <div className="self-center">
                    <img src="/images/VLSI/physicaldesign/place_and_route.png" />
                  </div>
                </div>
              </div>

              {/* card 6 */}
              <div
                className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg"
                id="PV"
              >
                <div className="flex flex-col lg:flex-row lg:items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl lg:text-4xl font-extrabold text-gray-900">
                      Physical Verification
                    </span>
                    <ul className="list-disc list-outside mt-4 text-gray-500 lg:text-lg flex flex-col gap-1">
                      <li>LVS</li>
                      <li>DRC</li>
                      <li>ERC</li>
                      <li>DFM</li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div className="self-center">
                    <img src="/images/VLSI/physicaldesign/physical_verification.png" />
                  </div>
                </div>
              </div>

              {/* card 7 */}
              <div
                className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg"
                id="TC"
              >
                <div className="flex flex-col lg:flex-row-reverse lg:items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl lg:text-4xl font-extrabold text-gray-900">
                      Timing Closure
                    </span>
                    <ul className="list-disc list-outside leading-relaxed mt-4 text-gray-500 lg:text-lg flex flex-col gap-1">
                      <li>Parasitic Extraction</li>
                      <li>Static Timing Analysis</li>
                      <li className="ml-4">
                      MMMC
                      </li>
                      <li>Timing ECO</li>
                      <li className="ml-4">DSTA, DMMMC</li>
                      <li className="ml-4">IR-Aware</li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div className="self-center">
                    <img src="/images/VLSI/physicaldesign/timing_closer.png" />
                  </div>
                </div>
              </div>
              {/* card 8 */}
              <div
                className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg"
                id="PA"
              >
                <div className="flex flex-col lg:flex-row lg:items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl lg:text-4xl font-extrabold text-gray-900">
                      Power/IR Analysis
                    </span>
                    <ul className="leading-relaxed mt-4 text-gray-500 lg:text-lg flex flex-col gap-1">
                      <li>Balance power consumption and speed</li>
                  
                    </ul>
                  </div>
                  {/* right content */}
                  <div className="self-center">
                    <img src="/images/VLSI/physicaldesign/ir_analysis.png" />
                  </div>
                </div>
              </div>

              {/* card 9 */}
              <div
                className="bg-gray-100  p-8 lg:px-16 lg:py-24 shadow-lg"
                id="ECO"
              >
                <div className="flex flex-col lg:flex-row-reverse lg:items-center gap-10">
                  {/* left content */}
                  <div className=" basis-2/6">
                    <span className="text-2xl lg:text-4xl font-extrabold text-gray-900">
                      Post-Silicon Metal-Only ECO
                    </span>
                    <ul className="leading-relaxed mt-4 text-gray-500 lg:text-lg flex flex-col gap-1">
                      <li>
                        Smart Spare distribution in early stage to accommodate
                        post-silicon changes in limited layers
                      </li>
                    </ul>
                  </div>
                  {/* right content */}
                  <div className="self-center">
                    <img src="/images/VLSI/physicaldesign/post_silicon_metal_only_eco.png" />
                  </div>
                </div>
              </div>
            </div>
            {/* right side content ENDS */}
          </div>
        </div>
      </section>
      {/* 3rd section ENDS  */}
      {/* home content ENDS */}
      {/* blogs starts */}
      {/* featured */}
      <div className="bg-gray-100 w-full py-10 sm:py-20">
        <div className="grid mid-home-column">
          <div className="pb-12 items-center flex flex-col">
            <h2 className="text-black font-headline items-center break-words text-center font-extrabold text-3xl md:text-4xl mb-1">
              Read what we wrote
            </h2>
            <p className="text-center flex font-headline items-center text-base md:text-xl leading-8 text-gray-600">
              Get front-row industry insights
            </p>
          </div>
          <div className="flex justify-center mx-5">
            <FeaturedBlogs
              how={props.featured.posts}
              path="/blogs/"
              title="VIEW DETAILS"
            />
          </div>
        </div>
      </div>

      {/* {showModal && <Modal />} */}

      <div className="hidden md:block md:footer-div absolute z-50 bg-black md:py-24 w-full px-10 xl:px-32">
        <Footer />
      </div>
      <div className="block md:hidden absolute z-50 bg-black py-10 w-full px-7">
        <MobileFooter />
      </div>
    </div>
  );
};

export default PhysicalDesign;
